import { useState } from "react";
import Container from "react-bootstrap/esm/Container";
import { useDispatch, useSelector } from "react-redux";
import { thunks as dataThunks } from "../global/slices/dataSlice";
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';

export default function Data() {
  const dispatch = useDispatch()
  const { isLoading, data, numDispatches } = useSelector(state => state.data)
  useState(() => {
    dispatch(dataThunks.fetchData())
  }, [dispatch, numDispatches])

  if (isLoading) return (
    <div id="overlay">
      <p className="my-3 fs-3 fw-bolder">Fetching data</p>
      <Spinner animation="border" variant="success" role="status"></Spinner>
    </div>
  )

  return (
    <Container>
      <h1 id="latest10">Registered devices : {data.numofminers}</h1>
      {/* <h2 id="latest10">Total number of records : {data.numofrecords}</h2> */}

      <h3 id="latest10">Latest 20 entries</h3>
      <Table bordered variant="dark" className="large-desktop">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">Score</th>
            <th scope="col">Temperature °C</th>
            <th scope="col">Humidity</th>
            <th scope="col">CO2</th>
            <th scope="col">Voc</th>
            <th scope="col">PM25</th>
            <th scope="col">Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {data.data.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item.timezone}</td>
              <td data-label="Score">{item.score}</td>
              <td data-label="Temperature">{item.temp}</td>
              <td data-label="Humidity">{item.humid}</td>
              <td data-label="CO2">{item.co2}</td>
              <td data-label="Voc">{item.voc}</td>
              <td data-label="PM25">{item.pm25}</td>
              <td data-label="Timestamp">{item.timestamp}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <h3 id="latest10">Average results per region</h3>
      <Table bordered variant="dark" className="no-responsive">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">Score</th>
          </tr>
        </thead>
        <tbody>
          {data.averagescore.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item._id}</td>
              <td data-label="Score" width="370">{item.averagescore.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <br />
      <Table bordered variant="dark" className="no-responsive">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">Temperature</th>
          </tr>
        </thead>
        <tbody>
          {data.averagetemp.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item._id}</td>
              <td data-label="Temperature" width="370">{item.averagetemp.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <br />
      <Table bordered variant="dark" className="no-responsive">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">Humidity</th>
          </tr>
        </thead>
        <tbody>
          {data.averagehum.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item._id}</td>
              <td data-label="Humidity" width="370">{item.averagehum.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <br />
      <Table bordered variant="dark" className="no-responsive">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">CO2</th>
          </tr>
        </thead>
        <tbody>
          {data.averageco2.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item._id}</td>
              <td data-label="CO2" width="370">{item.averageco2.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <br />
      <Table bordered variant="dark" className="no-responsive">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">Voc</th>
          </tr>
        </thead>
        <tbody>
          {data.averagevoc.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item._id}</td>
              <td data-label="Voc" width="370">{item.averagevoc.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <br />
      <Table bordered variant="dark" className="no-responsive">
        <thead>
          <tr id="table_th">
            <th scope="col">Region</th>
            <th scope="col">PM25</th>
          </tr>
        </thead>
        <tbody>
          {data.averagepm25.map((item, index) => (
            <tr key={index} id="table_td">
              <td data-label="Region">{item._id}</td>
              <td data-label="PM25" width="370">{item.averagepm25.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <br />
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
}

